import { IonContent } from "@ionic/react";
import DayUseProvider from "../context/DayUseContext";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import ScrollToTop from "../hooks/ScrollToTop";
import MaintenancePage from "../views/children/MaintenancePage/MaintenancePage";
import LoginPage from "../views/children/LoginPage/LoginPage";
import RouteLogic from "./RouteLogic";
import PrivacyAndPolicies from "../views/children/PrivacyAndPolicies/PrivacyAndPolicies";
import CookiePolicy from "../views/children/CookiePolicy/CookiePolicy";
import MainFooter from "../components/MainFooter/MainFooter";

const Index = () => {
  const { view, setView, switchPages } = RouteLogic();

  return (
    <>
      <ScrollToTop view={view} />

      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", flex: "1" }}>
          <IonContent forceOverscroll={false} id="content" className="key-board-offset-reset">
            <Switch>
              <Route exact path={"/maintenance"} component={MaintenancePage} />
              <Route path={"/privacy"} component={PrivacyAndPolicies} />
              <Route path={"/cookie"} component={CookiePolicy} />
              <DayUseProvider setView={setView} view={view}>
                <Route
                  path={["/dayexperiences", "/day-use-view"]}
                  render={() => switchPages(view)}
                />
                <Route
                  exact
                  path={"/"}
                  render={() => <LoginPage setView={setView} />}
                />
                <Redirect from="*" to="/" />
              </DayUseProvider>
            </Switch>
          </IonContent>
        </div>
        <div style={{ flex: "0" }}>
          <MainFooter />
        </div>
      </div>
    </>
  );
};

export default Index;
